import React from 'react';

import { MetricColor, Numbers } from '../../utils/typeConstants';
import './metricProgressBarCard.scss';

type MetricProgressBarCardProps={
    totalMetricsAttained: number;
    totalMetricsReported: number;
    totalMetricsTargeted: number;
}

export const MetricProgressBarCard = ({ totalMetricsAttained, totalMetricsReported, totalMetricsTargeted }: MetricProgressBarCardProps) => {
    const progressbarColor = [
        MetricColor.METRIC_1,
        MetricColor.METRIC_2,
        MetricColor.METRIC_3,
        MetricColor.METRIC_4,
        MetricColor.METRIC_5,
        MetricColor.METRIC_6,
        MetricColor.METRIC_7,
    ];

    const backgroundColorCode = (i: number) => {
        return progressbarColor[i];
    };

    const metricBar = () => {
        const arr = Array(totalMetricsAttained);

        const progressReturnValue = [];

        if (totalMetricsAttained) {
            for (let i = 0; i < arr?.length; i++) {
                progressReturnValue.push(
                    <div
                        key={i}
                        role="progressbar"
                        aria-label="Segment one"
                        style={{
                            width: `${Numbers.HUNDRED / totalMetricsReported}%`,
                            backgroundColor: `${backgroundColorCode(i)}`,
                        }}
                    />
                );
            }
        }

        return <div className="progress"> {progressReturnValue} </div>;
    };

    return (
        <div className="col-md-6 mt-2">
            <div style={{ float: 'right', transform: 'translateY(-50%)', width: '100%' }} className="mt-4">
                <span id="label_metricstatus" className="p-2 ps-0">
                    {` Payout begins at  ${totalMetricsTargeted}`}
                </span>

                {metricBar()}

                <div className="progress progressBarClass">
                    <div
                        className=""
                        role="progressbar"
                        aria-label="Segment one"
                        style={{ width: `${totalMetricsTargeted * (Numbers.HUNDRED / totalMetricsReported)}%`, borderRight: '2px solid #6c757d' }}
                    />
                    <div className="" role="progressbar" aria-label="Segment one">
                        <span className="targetSpan">Target</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
